export default "__VITE_ASSET__57b13ae2__"